module.exports = __webpack_public_path__ + "static/img/login_success.e0efa674.gif";